/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
import { toDoTaskService } from '../../api/services/toDoTaskService';
import { setToDoTaskData } from '../../infra/aggregates/getToDoTaskSlice';
import _ from 'lodash';
import { baseDateFormatting, convertUtcToDate } from '../../common/helper';

interface PropsValues {
  setToDoTaskDatas: (data: object) => void;
  textFilter?: any;
  refreshData: boolean;
}
function DTOToDoTask({
  setToDoTaskDatas,
  textFilter,
  refreshData,
}: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();

  async function getToDoTaskList(companyId: number, user_id: number) {
    const response: any = await toDoTaskService.getDoToTaskList(
      companyId,
      user_id,
    );
    if (response.response == 'success') {
      dispatch(setToDoTaskData(response.data));
      const toDoTaskDataList: any = _.map(response.data, (data: any) => {
        const rowData: any = {
          id: data?.id,
          candidate_name: data?.employee_boarding
            ? data.employee_boarding.name
            : '-',
          date_of_joining:
            data?.employee_boarding && data?.employee_boarding.date_of_joining
              ? convertUtcToDate(data.employee_boarding.date_of_joining, baseDateFormatting, null, false)
              : '-',
          task_name: data?.task_name,
          task_type: data?.task_type,
          remarks: data?.remarks,
          status_text: data?.status_text,
          status: data?.status,
        };
        return rowData;
      });

      if (textFilter.length) {
        const txt = textFilter.toLowerCase();
        const filteredData = _.filter(toDoTaskDataList, function (e) {
          return e?.candidate_name?.name.toLowerCase().includes(txt);
        });
        setToDoTaskDatas(filteredData);
      } else {
        setToDoTaskDatas(toDoTaskDataList);
      }
    }
  }
  useEffect(() => {
    if (selector.company_id && selector.user_id)
      getToDoTaskList(selector.company_id, selector.user_id);
  }, []);

  useEffect(() => {
    if (selector.company_id && selector.user_id && refreshData)
      getToDoTaskList(selector.company_id, selector.user_id);
  }, [refreshData]);
  return <></>;
}
export default DTOToDoTask;
